export default "/images/c7df5075f85854a218d60db9c2d54816.avif";